// src/i18n/texts.js
export const dict = {
  en: {
    nav: {
      home: "Home",
      advertise: "Advertise",
      monetize: "Monetize",
      faq: "FAQ",
      about: "About",
      contact: "Contact",
      login: "Log in",
    },
    home: {
      eyebrow: "WELCOME",
      title: ["Global App, Game", "& Content Connections"],
      desc:
        "AT GIVVY, WE BRING PEOPLE TOGETHER ACROSS THE GLOBE. WE PARTNER WITH APPS, GAMES, AND WEBSITES TO ELEVATE BRANDS, UNLOCK MONETIZATION OPPORTUNITIES, AND CONNECT USERS WITH GREAT CONTENT.",
      cta: { getStarted: "Get started", contact: "Contact" },
    },
    stats: {
      eyebrow: "ACHIEVEMENTS",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      payout: "100+",
      publishers: "Publishers",
      mau: "2M+",
      mauLabel: "Monthly Active Users",
      adv: "500+",
      advertisers: "Advertisers",
    },
    services: {
      eyebrow: "OUR SERVICES",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      advertise: {
        title: "Advertise",
        kicker: "",
        desc:
          "Boost your brand’s impact, engage a fresh audience, and unlock your product’s global potential.",
        cta: "Learn more",
      },
      monetize: {
        title: "Monetize",
        kicker: "",
        desc:
          "Generate revenue from your website or app with ease by partnering with us and unlocking a world of earning opportunities.",
        cta: "Learn more",
      },
    },
    advertiseAdvantages: {
      eyebrow: "SPECIFIC ADVANTAGES",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      cards: [
        {
          title: "DIRECT TRAFFIC",
          subtitle: "& Loyal Users",
          text:
            "At Givvy, our focus is on delivering direct, high-quality traffic to websites, apps, and games worldwide. Reaching a diverse international audience helps our clients enter new markets and grow their global reach.",
        },
        {
          title: "EXPERTISE",
          subtitle: "",
          text:
            "Our 10 years of experience will elevate your advertising strategy to new heights! With a wealth of industry knowledge and a track record of success, our seasoned team brings specialized skills and insights to the forefront.",
        },
        {
          title: "ADVANCED",
          subtitle: "Anti-fraud tools",
          text:
            "Protect your business from fraud and chargebacks with our advanced anti-fraud tools. With years of industry expertise, we have built an unshakable reputation for delivering high-quality traffic and maintaining a low chargeback rate. Partner with us for reliable results and peace of mind.",
        },
      ],
    },
    advertiseRewarded: {
      eyebrow: "REWARDED ADS?",
      titleLine1: "Forced To Watch The",
      titleLine2: "Wrong Ads At The Wrong Time",
      desc:
        "With rewarded ads users choose when and how to engage, creating a seamless experience. Capture their undivided attention and build brand loyalty. Say goodbye to interruptions, embrace rewarded ads, and elevate your advertising strategy!",
      imageAlt: "3D monitor illustration for rewarded ads",
    },
    advertiseTraffic: {
      eyebrow: "TRAFFIC TYPES",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      cards: [
        {
          title: "CPI",
          subtitle: "Cost Per Install",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPI icon",
        },
        {
          title: "CPE",
          subtitle: "Cost Per Engagement",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPE icon",
        },
        {
          title: "CPC",
          subtitle: "Cost Per Click",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPC icon",
        },
        {
          title: "CPA",
          subtitle: "Cost Per Action",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPA icon",
        },
      ],
    },
    advertiseSelfServe: {
      eyebrow: "SELF-SERVE PLATFORM",
      titleLine1: "From Installs",
      titleLine2: "To A Tailored User Base",
      desc:
        "Lead the online advertising world with our advanced self-serve platform. Manage campaigns, budgets, and target markets effortlessly. Unlock powerful exposure through our exclusive in-house direct traffic. Take control, and pave your path to success!",
      cta: "Get Started",
      imageAlt: "Self-serve platform dashboard illustration",
    },
    contactForm: {
      eyebrow: "CONTACT US",
      titleLine1: "Let Us Know What's",
      titleLine2: "On Your Mind",
      fields: {
        nameLabel: "Your Name",
        namePlaceholder: "Name",
        roleLabel: "You are",
        rolePlaceholder: "I'm an Advertiser",
        emailLabel: "Your E-mail",
        emailPlaceholder: "E-mail",
        messageLabel: "Your Message",
        messageHelper: "Let us know the details of your case.",
        messagePlaceholder: "Type here",
      },
      roleOptions: [
        { label: "I'm an Advertiser", value: "advertiser" },
        { label: "I'm a Publisher", value: "publisher" },
        { label: "Other", value: "other" },
      ],
      submit: "Submit",
    },
    monetizeHero: {
      eyebrow: "JOIN US",
      titleLine1: "Register And Enjoy All The Benefits",
      titleLine2: "Our Platform Has To Offer",
      desc: "To get started please choose the best option that describes you.",
      ctaPublisher: "Publisher",
      ctaAdvertiser: "Advertiser",
      imageAlt: "Illustration of a handshake for partners",
    },
    monetizeOverview: {
      eyebrow: "FEATURED PRODUCT",
      titleLine1: "Mobile",
      titleLine2: "Offerwall SDK",
      desc:
        "Our offerwall SDK runs on both Android and iOS games as well as reward apps. Our SDK is lightweight and easy to integrate. Let us help you increase your revenues.",
      ctaGetStarted: "Get started",
      ctaContact: "Contact",
      imageAlt: "Offerwall SDK preview",
    },
    monetizeAdvantages: {
      eyebrow: "SPECIFIC ADVANTAGES",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      cards: [
        {
          title: "LIGHTWEIGHT",
          subtitle: "",
          text:
            "Our SDK delivers lightweight, seamless monetization for apps and games, ideal for publishers who want an offerwall that won’t slow their experience down.",
          iconAlt: "Feather icon",
        },
        {
          title: "NATIVE IN THE APP",
          subtitle: "",
          text:
            "Our SDK integrates directly into your app or game, providing a seamless, uninterrupted experience for your audience.",
          iconAlt: "Native integration icon",
        },
      ],
    },
    monetizeSteps: {
      eyebrow: "HOW IT WORKS",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      steps: [
        {
          title:
            "Users choose to open Givvy’s offerwall from within your website or app.",
          label: "01",
          iconAlt: "Offerwall launch icon",
        },
        {
          title: "They are presented with various campaigns, offers, and surveys.",
          label: "02",
          iconAlt: "Campaigns icon",
        },
        {
          title:
            "They sort and filter the wall to find the best offers that suit them most.",
          label: "03",
          iconAlt: "Sorting icon",
        },
        {
          title: "They complete the required action of the campaign.",
          label: "04",
          iconAlt: "Completion icon",
        },
        {
          title: "The users are credited with your virtual currency.",
          label: "05",
          iconAlt: "Reward icon",
        },
      ],
    },
    faqHero: {
      eyebrow: "QUESTIONS",
      titleLine1: "Frequently Asked",
      titleLine2: "Questions",
      desc:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      imageAlt: "3D question mark illustration",
    },
    faqTabs: [
      {
        id: "advertise",
        label: "Advertise",
        faqs: [
          {
            q: "How can I advertise my product or service with you?",
            a:
              "To advertise on our platform, simply sign up as an advertiser and get your account approved. Once approved, you can easily create and manage your campaigns through our user-friendly interface. Just set your targeting preferences, define your campaign goals, and choose the type of offers you want to promote.",
          },
          {
            q: "What types of offers can I promote with you?",
            a:
              "We support various types of offers, including app installations, surveys, trials, registrations, and more. You have the flexibility to choose the offer types that best align with your product or service.",
          },
          {
            q: "How do you ensure quality traffic for my offers?",
            a:
              "We have a strict quality control system in place to ensure that the traffic you receive meets your expectations. Our system utilizes fraud detection algorithms, IP filtering, and compliance monitoring to minimize fraudulent or low-quality traffic.",
          },
          {
            q: "Can I target specific audiences for my offers?",
            a:
              "Absolutely! We offer advanced targeting options to help you reach your desired audience. You can target users based on location, device type, language, and more. Our targeting tools ensure that your offers are shown to the most relevant users, increasing the chances of conversion.",
          },
          {
            q: "How do I track the performance of my campaigns?",
            a:
              "We provide comprehensive tracking and reporting tools that allow you to monitor the performance of your campaigns in real-time. You can track key metrics such as clicks, conversions, and revenue. Our detailed reporting enables you to optimize your campaigns based on data-driven insights.",
          },
          {
            q: "What are the payment options available for advertisers?",
            a:
              "We support various payment options, including wire transfer, PayPal, and other electronic payment methods. Our platform offers flexibility and convenience in managing your advertising budget.",
          },
          {
            q: "Can I integrate OfferToro with my existing tracking system?",
            a:
              "Yes, we offer seamless integration with popular tracking systems through postback URLs and other integration methods. This allows you to consolidate data and streamline your campaign tracking process.",
          },
          {
            q: "How do you attract traffic?",
            a:
              "We attract traffic through our network of publishers who feature some of our offers on their websites. Additionally, we use the 'double incentive' method during specific periods, which has proven to be effective in attracting traffic.",
          },
        ],
      },
      {
        id: "monetize",
        label: "Monetize",
        faqs: [
          {
            q: "I want to monetize my users with Givvy, how can I do that?",
            a:
              "If you are a web/app developer, you can sign up for our Torox platform and choose from our different monetization solutions: web-based offerwall, Mobile-SDK offerwall, or our API.",
          },
          {
            q: "What do I need to provide to start monetizing with you?",
            a:
              "You are not required to provide any prepayment or commitment. You can start monetizing with us freely, and you can always stop our partnership if it does not suit your business needs. This is a risk-free partnership!",
          },
          {
            q: "What are the requirements for publishers who want to use our solution?",
            a:
              "Our solutions are designed for publishers who have a game economy or a platform that can reward the user with virtual currency or other benefits. This means that the user can use the virtual currency to make in-app purchases, access premium features, or withdraw it for real money. If you have such a game economy or platform, you can integrate our solution and offer your users a variety of offers to complete for rewards.",
          },
          {
            q: "What is virtual currency?",
            a:
              "Our offers reward your users using your platform’s virtual currency - a coin they can use on your platform or app for the services you offer.",
          },
          {
            q: "How do your users benefit from the offerwall?",
            a:
              "Once users engage with our offerwall, they can use the virtual currency they earned to advance in your game or to redeem in exchange for rewards that you provide, for example, gift cards, cryptocurrency, and game skins.",
          },
          {
            q: "What kind of users will benefit from the offerwall?",
            a:
              "Most users are not spenders - they don’t make in-app purchases (IAP) in order to advance in games. Torox helps you maximize your revenue with users. These users can actively complete our offers and both you and your users benefit.",
          },
          {
            q: "What type of offers will my users have access to?",
            a:
              "Torox has a wide variety of offers your users can choose from. Your users can choose to do offers that take a few seconds (install an app, sign up for a service). Your users can choose to play high-quality games with multiple awards along the way. You can choose what categories of offers your users will see and your users have the freedom to choose what they want to do and how.",
          },
          {
            q: "How will I receive my payments?",
            a:
              "We have a monthly payment cycle and you will receive your payments automatically via bank transfer or PayPal payment. All the information is presented clearly and transparently. Throughout the years we’ve worked with thousands of publishers who have learned to trust our consistent payments.",
          },
        ],
      },
      {
        id: "missing",
        label: "Missing your reward?",
        faqs: [
          {
            q: "I completed an offer but didn't receive my reward.",
            a:
              "If you've completed an offer but haven't received your reward within 24 hours, you can submit a ticket with proof and our support team will check it.",
          },
          {
            q: "My status is pending. What does this mean?",
            a:
              "If your reward is pending, it means that we didn’t find any valid completion on our side and we reached out to the advertiser for further investigation and we will keep you updated.",
          },
          {
            q: "What do I do if I don't see my offer?",
            a:
              "If you can't find the offer you're looking for, please reach out to the app/website where the offerwall is displayed.",
          },
        ],
      },
    ],
    registerForm: {
      eyebrow: "REGISTER",
      titleLine1: "Already Registered?",
      loginCta: "Log in",
      submit: "Submit",
      fields: {
        company: { label: "Company", placeholder: "Company name" },
        contactPerson: { label: "Contact person", placeholder: "John Smith" },
        email: { label: "Your E-mail", placeholder: "E-mail" },
        country: { label: "Your Country", placeholder: "Select your country" },
        communicationLabel: "Communication Platform Account",
        communicationOptions: [
          { label: "Skype", value: "skype" },
          { label: "Slack", value: "slack" },
          { label: "Telegram", value: "telegram" },
          { label: "WhatsApp", value: "whatsapp" },
        ],
        communicationHandle: {
          label: "Communication Platform Account",
          placeholder: "Communication",
        },
        appLink: { label: "App/Website Link", placeholder: "Link" },
        dau: { label: "Daily Active Users", placeholder: "Active users" },
        revenue: { label: "Monthly Revenue", placeholder: "Revenue" },
        revenueOptions: [
          { label: "0 - 20K", value: "0-20k" },
          { label: "20K - 50K", value: "20-50k" },
          { label: "50K - 100K", value: "50-100k" },
          { label: "100K - 500K", value: "100-500k" },
          { label: "500K+", value: "500k+" },
        ],
        message: {
          label: "Your Message",
          helper: "Let us know details of your case.",
          placeholder: "Type here",
        },
      },
    },
    loginModal: {
      eyebrow: "LOGIN",
      title: "Access your account",
      subtitle: "Use your advertiser/publisher credentials or API key to continue.",
      emailLabel: "Email",
      emailPlaceholder: "you@example.com",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter your password",
      apiKeyLabel: "API key (optional)",
      apiKeyPlaceholder: "Paste your API key",
      submit: "Log in",
      helper: "Need help? Contact us and we will assist you.",
      success: "Logged in successfully.",
      missingFields: "Add email & password or API key.",
      genericError: "Unable to log in. Please try again.",
    },
    registerModal: {
      eyebrow: "REGISTER",
      title: "Create your account",
      subtitle: "Share your business details so we can onboard you faster.",
      submit: "Register",
      success: "Registered successfully.",
      missingFields: "Please fill the required fields.",
      genericError: "Unable to register. Please try again.",
      emailLabel: "Email",
      emailPlaceholder: "you@example.com",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter a password",
      companyLabel: "Company",
      companyPlaceholder: "Company name",
      contactLabel: "Contact person",
      contactPlaceholder: "Full name",
      countryLabel: "Country",
      countryPlaceholder: "Select country",
      commPlatformLabel: "Communication platform",
      commHandleLabel: "Handle",
      commHandlePlaceholder: "Username",
      appLabel: "App/Website link",
      appPlaceholder: "Link",
      dauLabel: "Daily Active Users",
      dauPlaceholder: "Active users",
      revenueLabel: "Monthly Revenue",
      revenuePlaceholder: "Revenue",
      messageLabel: "Message",
      messagePlaceholder: "Describe your business",
      languageLabel: "Language",
      communicationOptions: [
        { label: "Skype", value: "skype" },
        { label: "Slack", value: "slack" },
        { label: "Telegram", value: "telegram" },
        { label: "WhatsApp", value: "whatsapp" },
      ],
    },
    registerSuccess: {
      eyebrow: "VERIFY EMAIL",
      title: "Check your email",
      subtitle: "We sent a verification link to {email}. Please confirm to finish your registration.",
      cta: "Got it",
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Review and edit your account information.",
      save: "Save changes",
    },
    whyUs: {
      eyebrow: "WHY US",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      cards: [
        {
          title: "GLOBAL",
          subtitle: "& Direct Traffic",
          text:
            "At Givvy, our focus is on delivering direct, high-quality traffic to websites, apps, and games worldwide. Reaching a diverse international audience helps our clients enter new markets and grow their global reach.",
        },
        {
          title: "TRANSPARENCY",
          subtitle: "& Responsivity",
          text:
            "We believe transparency and responsiveness are the foundation of strong, lasting partnerships. We prioritize open communication and clear expectations with our clients, partners, and users.",
        },
        {
          title: "IN-HOUSE TECHNOLOGICAL",
          subtitle: "Solutions",
          text:
            "Our in-house technology gives us a competitive edge, letting us deliver end-to-end services without sacrificing quality. By building and owning our tools, we streamline processes, boost efficiency, and keep full control of delivery.",
        },
      ],
    },
    partners: {
      eyebrow: "WHY US",
      titleLine1: "Our Results Speak For",
      titleLine2: "Themselves",
      brands: [
        { name: "Qmee", alt: "Qmee logo" },
        { name: "Prodege", alt: "Prodege logo" },
        { name: "WebToon", alt: "WebToon logo" },
        { name: "Exmox", alt: "Exmox logo" },
        { name: "AdGateMedia", alt: "AdGateMedia logo" },
        { name: "TV-TWO", alt: "TV-TWO logo" },
        { name: "timewall", alt: "Timewall logo" },
        { name: "AyeT Studios", alt: "AyeT Studios logo" },
      ],
    },
    footer: {
      brandName: "Givvy",
      brandText:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt.",
      storeCta: "Store",

      menuTitle: "",
      menuItems: [ "Team", "Careers"],

      infoTitle: "Services",
      infoItems: [{ label: "Monetize", href: "/monetize" }, { label: "Advertise", href: "/advertise" }],

      extraTitle: "Solutions",
      extraItems: ["OfferWall", "SDK"],

      extraTitle2: "FAQ",
      extraItems2: ["Advertisers", "Publishers"],

      extraTitle3: "Contact",
      extraItems3: [{ label: "Register", href: "/registerPublisher" }, { label: "Log in", href: "/registerAdvertiser" }],

      copyright: "Copyright 2024 © Givvy",

      social: ["Facebook", "Instagram", "YouTube", "Telegram", "X", "TikTok"],
    },
  },

  bg: {
    nav: {
      home: "Начало",
      advertise: "Реклама",
      monetize: "Монетизация",
      faq: "FAQ",
      about: "За нас",
      contact: "Контакт",
      login: "Вход",
    },
    home: {
      eyebrow: "ДОБРЕ ДОШЛИ",
      title: ["Глобални връзки", "между апове, игри и съдържание"],
      desc:
        "В GIVVY СВЪРЗВАМЕ ХОРАТА ПО СВЕТА. РАБОТИМ С АПОВЕ, ИГРИ И САЙТОВЕ, ЗА ДА ПОДОБРЯВАМЕ БРАНДОВЕ, ДА ПРЕДОСТАВЯМЕ ВЪЗМОЖНОСТИ ЗА МОНЕТИЗАЦИЯ И ДА ПОКАЗВАМЕ ОТЛИЧНО СЪДЪРЖАНИЕ.",
      cta: { getStarted: "Започни", contact: "Контакт" },
    },
    stats: {
      eyebrow: "ПОСТИЖЕНИЯ",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      payout: "$1M+",
      publishers: "Издатели",
      mau: "20M+",
      mauLabel: "Месечно активни потребители",
      adv: "150K+",
      advertisers: "Рекламодатели",
    },
    services: {
      eyebrow: "НАШИТЕ УСЛУГИ",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      advertise: {
        title: "Реклама",
        kicker: "LOREM IPSUM",
        desc:
          "Повиши въздействието на своя бранд, достигни до нова аудитория и отключи глобалния потенциал на продукта си.",
        cta: "Научи повече",
      },
      monetize: {
        title: "Монетизация",
        kicker: "LOREM IPSUM",
        desc:
          "Превърни трафика си в реални приходи чрез надеждни и прозрачни решения за монетизация.",
        cta: "Научи повече",
      },
    },
    advertiseAdvantages: {
      eyebrow: "СПЕЦИФИЧНИ ПРЕДИМСТВА",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      cards: [
        {
          title: "ДИРЕКТЕН ТРАФИК",
          subtitle: "и лоялни потребители",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "ЕКСПЕРТИЗА",
          subtitle: "Lorem ipsum",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "НАПРЕДНАЛИ",
          subtitle: "Anti-fraud инструменти",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
      ],
    },
    advertiseRewarded: {
      eyebrow: "REWARDED ADS?",
      titleLine1: "Потребителите избират",
      titleLine2: "кога да гледат реклами",
      desc:
        "С rewarded реклами хората решават кога и как да се ангажират, което носи безшевно преживяване. Грабни пълното им внимание и изгради лоялност към бранда. Кажи сбогом на прекъсванията и вдигни рекламната си стратегия на следващо ниво!",
      imageAlt: "3D илюстрация на монитор за rewarded реклами",
    },
    advertiseTraffic: {
      eyebrow: "ТИПОВЕ ТРАФИК",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      cards: [
        {
          title: "CPI",
          subtitle: "Cost Per Install",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPI икона",
        },
        {
          title: "CPE",
          subtitle: "Cost Per Engagement",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPE икона",
        },
        {
          title: "CPC",
          subtitle: "Cost Per Click",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPC икона",
        },
        {
          title: "CPA",
          subtitle: "Cost Per Action",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          iconAlt: "CPA икона",
        },
      ],
    },
    advertiseSelfServe: {
      eyebrow: "SELF-SERVE PLATFORM",
      titleLine1: "От инсталации",
      titleLine2: "до таргетирана аудитория",
      desc:
        "Поведи света на онлайн рекламата с нашата self-serve платформа. Управлявай кампании, бюджети и пазари без усилие, възползвай се от директния ни трафик и поеми контрол над успеха си.",
      cta: "Започни",
      imageAlt: "Илюстрация на self-serve платформа",
    },
    contactForm: {
      eyebrow: "КОНТАКТ",
      titleLine1: "Сподели с нас",
      titleLine2: "какво те вълнува",
      fields: {
        nameLabel: "Име",
        namePlaceholder: "Име",
        roleLabel: "Ти си",
        rolePlaceholder: "Аз съм рекламодател",
        emailLabel: "Твоят имейл",
        emailPlaceholder: "Имейл",
        messageLabel: "Съобщение",
        messageHelper: "Разкажи ни повече за твоя случай.",
        messagePlaceholder: "Пиши тук",
      },
      roleOptions: [
        { label: "Аз съм рекламодател", value: "advertiser" },
        { label: "Аз съм издател", value: "publisher" },
        { label: "Друго", value: "other" },
      ],
      submit: "Изпрати",
    },
    monetizeHero: {
      eyebrow: "ПРИСЪЕДИНИ СЕ",
      titleLine1: "Регистрирай се и усети всички",
      titleLine2: "ползите на нашата платформа",
      desc: "Избери опцията, която те описва най-добре, за да започнеш.",
      ctaPublisher: "Партньор",
      ctaAdvertiser: "Рекламодател",
      imageAlt: "Илюстрация на ръкостискане",
    },
    monetizeOverview: {
      eyebrow: "ХИТ ПРОДУКТ",
      titleLine1: "Mobile",
      titleLine2: "Offerwall SDK",
      desc:
        "Нашият Offerwall SDK работи на Android и iOS игри, както и в reward приложенията. Лек е и се интегрира лесно, за да ти помогне да увеличиш приходите.",
      ctaGetStarted: "Започни",
      ctaContact: "Контакт",
      imageAlt: "Визуализация на Offerwall SDK",
    },
    monetizeAdvantages: {
      eyebrow: "СПЕЦИФИЧНИ ПРЕДИМСТВА",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      cards: [
        {
          title: "ЛЕК",
          subtitle: "Lorem ipsum",
          text:
            "Леко и безпроблемно решение за монетизация, идеално за издатели, които искат offerwall без да тежи на техните игри или апове.",
          iconAlt: "Икона перо",
        },
        {
          title: "НАТИВЕН В АПА",
          subtitle: "Lorem ipsum",
          text:
            "SDK-то се интегрира нативно с твоя ап или игра и осигурява непрекъснато и консистентно потребителско изживяване.",
          iconAlt: "Икона интеграция",
        },
      ],
    },
    monetizeSteps: {
      eyebrow: "КАК РАБОТИ",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      steps: [
        {
          title: "Потребителите отварят offerwall-а на Givvy във твоя сайт или ап.",
          label: "01",
          iconAlt: "Икона старт",
        },
        {
          title: "Получават различни кампании, оферти и анкети.",
          label: "02",
          iconAlt: "Икона кампании",
        },
        {
          title: "Филтрират стената, за да намерят най-подходящите оферти.",
          label: "03",
          iconAlt: "Икона филтър",
        },
        {
          title: "Изпълняват нужните действия по кампанията.",
          label: "04",
          iconAlt: "Икона завършване",
        },
        {
          title: "Получават кредити във виртуалната валута.",
          label: "05",
          iconAlt: "Икона награда",
        },
      ],
    },
    faqHero: {
      eyebrow: "ВЪПРОСИ",
      titleLine1: "Често задавани",
      titleLine2: "въпроси",
      desc:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      imageAlt: "3D въпросник",
    },
    faqTabs: [
      {
        id: "advertise",
        label: "Advertise",
        faqs: [
          {
            q: "Как мога да рекламирам своя продукт или услуга при вас?",
            a:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.",
          },
          {
            q: "Какви оферти мога да промотирам?",
            a:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          },
          {
            q: "Как гарантирате качествен трафик?",
            a:
              "Комбинация от курирани издатели, собствена анти-фрод система и ръчни проверки гарантират всяко показване.",
          },
          {
            q: "Мога ли да таргетирам конкретни аудитории?",
            a:
              "Да, чрез гео, устройство, интереси и поведенчески филтри в контролния панел.",
          },
          {
            q: "Какви платежни методи предлагате?",
            a:
              "Банков превод, PayPal, кредитни карти и персонализирани фактури според акаунта.",
          },
        ],
      },
      {
        id: "monetize",
        label: "Monetize",
        faqs: [
          {
            q: "Как работи споделянето на приходите?",
            a:
              "Зависи от качеството на трафика и вертикала. Мениджърът ти ще предложи най-добрата структура.",
          },
          {
            q: "Какви SDK-та поддържате?",
            a:
              "Предлагаме нативни SDK за Android и iOS плюс JS widget за уеб/хибридни приложения.",
          },
        ],
      },
      {
        id: "missing",
        label: "Missing your reward?",
        faqs: [
          {
            q: "Потребител не получи точки. Какво правя?",
            a:
              "Подай тикет с user ID, offer ID и дата. Разглеждаме случаите до 24 часа.",
          },
          {
            q: "Колко време отнема потвърждаване на наградата?",
            a:
              "Повечето оферти са мигновени, но някои изискват до 48 часа според рекламодателя.",
          },
        ],
      },
    ],
    registerForm: {
      eyebrow: "РЕГИСТРАЦИЯ",
      titleLine1: "Вече имаш акаунт?",
      loginCta: "Вход",
      submit: "Изпрати",
      fields: {
        company: { label: "Компания", placeholder: "Име на компания" },
        contactPerson: { label: "Контактно лице", placeholder: "Име" },
        email: { label: "Имейл", placeholder: "Имейл" },
        country: { label: "Държава", placeholder: "Избери държава" },
        communicationLabel: "Комуникационен канал",
        communicationOptions: [
          { label: "Skype", value: "skype" },
          { label: "Slack", value: "slack" },
          { label: "Telegram", value: "telegram" },
          { label: "WhatsApp", value: "whatsapp" },
        ],
        communicationHandle: {
          label: "Акаунт",
          placeholder: "Потребителско име",
        },
        appLink: { label: "Линк към ап/сайт", placeholder: "URL" },
        dau: { label: "Дневно активни", placeholder: "Потребители" },
        revenue: { label: "Месечен оборот", placeholder: "Оборот" },
        revenueOptions: [
          { label: "0 - 20K", value: "0-20k" },
          { label: "20K - 50K", value: "20-50k" },
          { label: "50K - 100K", value: "50-100k" },
          { label: "100K - 500K", value: "100-500k" },
          { label: "500K+", value: "500k+" },
        ],
        message: {
          label: "Съобщение",
          helper: "Разкажи ни повече за твоя случай.",
          placeholder: "Пиши тук",
        },
      },
    },
    loginModal: {
      eyebrow: "ВХОД",
      title: "Влез в акаунта си",
      subtitle: "Въведи имейл и парола или API ключ, за да продължиш.",
      emailLabel: "Имейл",
      emailPlaceholder: "name@email.com",
      passwordLabel: "Парола",
      passwordPlaceholder: "Парола",
      apiKeyLabel: "API ключ (по избор)",
      apiKeyPlaceholder: "Постави своя API ключ",
      submit: "Вход",
      helper: "Имаш затруднения? Пиши ни и ще помогнем.",
      success: "Успешен вход.",
      missingFields: "Въведи имейл и парола или API ключ.",
      genericError: "Неуспешен вход. Опитай отново.",
    },
    registerModal: {
      eyebrow: "РЕГИСТРАЦИЯ",
      title: "Създай акаунт",
      subtitle: "Попълни бизнес детайли, за да те онборднем по-бързо.",
      submit: "Регистрация",
      success: "Успешна регистрация.",
      missingFields: "Попълни задължителните полета.",
      genericError: "Неуспешна регистрация. Опитай отново.",
      emailLabel: "Имейл",
      emailPlaceholder: "name@email.com",
      passwordLabel: "Парола",
      passwordPlaceholder: "Въведи парола",
      companyLabel: "Компания",
      companyPlaceholder: "Име на компания",
      contactLabel: "Контактно лице",
      contactPlaceholder: "Име",
      countryLabel: "Държава",
      countryPlaceholder: "Избери държава",
      commPlatformLabel: "Канал за комуникация",
      commHandleLabel: "Потребител",
      commHandlePlaceholder: "Потребителско име",
      appLabel: "Линк към ап/сайт",
      appPlaceholder: "URL",
      dauLabel: "Дневно активни",
      dauPlaceholder: "Потребители",
      revenueLabel: "Месечен оборот",
      revenuePlaceholder: "Оборот",
      messageLabel: "Съобщение",
      messagePlaceholder: "Разкажи ни повече",
      languageLabel: "Език",
      communicationOptions: [
        { label: "Skype", value: "skype" },
        { label: "Slack", value: "slack" },
        { label: "Telegram", value: "telegram" },
        { label: "WhatsApp", value: "whatsapp" },
      ],
    },
    registerSuccess: {
      eyebrow: "ПОТВЪРДИ",
      title: "Провери имейла си",
      subtitle: "Изпратихме линк за потвърждение на {email}. Моля, кликни го, за да завършиш регистрацията.",
      cta: "Готово",
    },
    dashboard: {
      title: "Табло",
      subtitle: "Виж и редактирай информацията за твоя акаунт.",
      save: "Запази промените",
    },
    whyUs: {
      eyebrow: "ЗАЩО НИЕ",
      titleLine1: "Нашите резултати",
      titleLine2: "говорят сами",
      cards: [
        {
          title: "ГЛОБАЛЕН",
          subtitle: "директен трафик",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "ПРОЗРАЧНОСТ",
          subtitle: "и бърза реакция",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "СОБСТВЕНИ ТЕХНОЛОГИЧНИ",
          subtitle: "решения",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
      ],
    },
    partners: {
      eyebrow: "ПАРТНЬОРИ",
      titleLine1: "Брандове, които",
      titleLine2: "ни се довериха",
      brands: [
        { name: "Qmee", alt: "Qmee лого" },
        { name: "Prodege", alt: "Prodege лого" },
        { name: "WebToon", alt: "WebToon лого" },
        { name: "Exmox", alt: "Exmox лого" },
        { name: "AdGateMedia", alt: "AdGateMedia лого" },
        { name: "TV-TWO", alt: "TV-TWO лого" },
        { name: "timewall", alt: "Timewall лого" },
        { name: "AyeT Studios", alt: "AyeT Studios лого" },
      ],
    },
    footer: {
      brandName: "Givvy",
      brandText:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt.",
      storeCta: "Магазин",

      menuTitle: "Меню",
      menuItems: ["Начало", "Статистики", "Топ оферти", "Приложения", "Нашите ценности"],

      infoTitle: "Информация",
      infoItems: [
        "Общи условия",
        "Политика за поверителност",
        "Условия за insertion order",
      ],

      copyright: "Copyright 2024 © Givvy",

      social: ["Facebook", "Instagram", "YouTube", "Telegram", "X", "TikTok"],
    },
  },
};
